import { ApiToken } from "../../plugins/api";
import { AffecteToken } from "../../plugins/api";
import moment from "moment";
import axios from "axios";

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;

export default {
  AffecteToken,
  dialog: {
    informations: {
      model: false,
      texte: "",
    },
  },
  liste: [],
  creer: false,
  DonneesFormulaireEC: {
    conditionsGenerales : false,
    listeAnnexesFirsi:[],
    autresRevenusCandidat: [],
    resumeCandidature: null,
    publipostageSigne: {
      nomFichier: null,
      donneePieceJointe: null,
    },
    photo: {
      nomFichier: null,
      donneePieceJointe: null,
    },
    infosComplementaires: {},
    etatDossier: { id: null, lang00: null },
  },
  verificationCni: {
    cni: null,
    afficherMessage: false,
    cniVerifie: false,
    candidatureExistante:false,
  },
  premiereEtape: {
    cniValide: false,
    creer: false,
    afficherMessage: false,
    peutCreer:true,
  },
  loader: true,
  utilisateurConnecte: true,
  validation: {
    candidat: false,
    fratrie: false,
    parentTuteur: false,
    publipostage: false,
    revenu: false,
  },
  async GetListe(token) {
    this.loader = true;
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("candidatureBourseFirsi/GetListe");
  },
  async GetFicheByToken(token) {
    const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token, 
        },
      })
      .get(`candidatureBourseFirsi/Formulaire?ecoleCentrale=${true}`);
    return reponse;
  },
  async GetFiche(id, token) {
    this.loader = true;

    try {
      const response = await axios
        .create({
          baseURL: process.env.VUE_APP_BASE_API_URL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
            token: token, 
          },
        })
        .get(`candidatureBourseFirsi/GetFiche/${id}`);

      // Affectation des données avec vérification
      if (response.data && response.status === 200) {
        this.DonneesFormulaireEC = JSON.parse(JSON.stringify(response.data)); // Conversion pour retirer les observables
        this.DonneesFormulaireEC.conditionsGenerales = true;
        this.utilisateurConnecte = true;
      } else {
        throw new Error("Réponse API invalide");
      }
    } catch (error) {
      console.error("Erreur:", error);
      this.utilisateurConnecte = false;
      this.DonneesFormulaireEC = {}; // Réinitialisation
      // Optionnel : Afficher un message d'erreur à l'utilisateur
    } finally {
      this.loader = false;
    }
  },
  ConvertDateApiToDateVue(dateApi) {
    if (dateApi) {
      return moment(dateApi, "YYYY-MM-DD[T]hh:mm:ss").format("YYYY-MM-DD");
    } else {
      return null;
    }
  },
  FormatDate(date) {
    if (!date) return null;
    date = this.ConvertDateApiToDateVue(date);
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  },
  editedIndex: -1,
  editedItem: { autreRevenuDto: {} },
  editItem(item, liste) {
    // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
    this.editedIndex = liste.indexOf(item);
    this.editedItem = Object.assign({}, item);
  },
  deleteItem(item, liste) {
    // on récupère l'item depuis le store
    this.editedIndex = liste.indexOf(item);
    // on affecte l'item local pour récupèrer les valeurs
    this.editedItem = Object.assign({}, item);

    // on affecte la valeur supprimer à true
    this.editedItem.supprimer = true;

    // on modifie l'item dans le store
    Object.assign(liste[this.editedIndex], this.editedItem);

    // appel le close pour désaffecter l'item local
    this.close();
    return liste;
  },
  close(item) {
    // on remet à zéro le editedItem local
    this.editedItem = Object.assign({}, item);

    this.editedIndex = -1;
  },
  save(liste) {
    // on passe le item local à false.
    this.editedItem.supprimer = false;

    // on modifie l'item dans le store si l'editedIndex est renseigné.
    if (this.editedIndex > -1) {
      Object.assign(liste[this.editedIndex], this.editedItem);
    }
    // sinon, on ajoute l'item local au store.
    else {
      let index = liste.length + 1;
      this.editedItem.index = index;
      liste.push(this.editedItem);
    }
  },
  CalculerNombreTuteurs(dataIdOui) {
    if (dataIdOui && this.DonneesFormulaireEC.listeSituationsFamiliale) {
      return this.DonneesFormulaireEC.listeSituationsFamiliale.filter(
        (item) => {
          return item.supprimer == false && item.tuteur == dataIdOui;
        }
      ).length;
    }

    return 0;
  },
  VerifierTuteur(show, storeCatalogue) {
    const nbTuteurs = this.CalculerNombreTuteurs(storeCatalogue.DataId.Oui);

    // Vérifier si au moins un tuteur est présent.
    if (
      nbTuteurs < 1 &&
      this.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale &&
      this.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale !=
        storeCatalogue.DataId.Oui
    ) {
      const texte =
        "Merci de renseigner au moins un tuteur. Auquel cas, merci de revenir à l'étape 'Informations personnelles' et de répondre oui à la question 'Provenez-vous d'un établissement social ?'";
      if (show) {
        let retour = {
          model: true,
          texte: texte,
        };
        return retour;
      }

      return [texte];
    }

    let etesVous = this.DonneesFormulaireEC.infosComplementaires.etesVous;

    // Si à la charge de 2 parents mariés, vérifier qu'on a bien au moins 2 parents tuteurs.
    if (
      etesVous &&
      etesVous ==
        storeCatalogue.DataId.ChargeDeuxParentsMaries &&
      this.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale &&
      this.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale !=
        storeCatalogue.DataId.Oui
    ) {
      if (nbTuteurs < 2) {
        const texte =
          "Vous avez indiqué être à la charge de deux parents mariés, merci d'ajouter ici vos deux parents.";
        if (show) {
          let retour = {
            model: true,
            texte: texte,
          };
          return retour;
        }

        return [texte];
      }

      // Vérifier si on a bien 2 parents tuteur au statut mariés.
      let parentsMaries =
        this.DonneesFormulaireEC.listeSituationsFamiliale.filter((item) => {
          return (
            item.supprimer == false &&
            item.tuteur == storeCatalogue.DataId.Oui &&
            item.statutParentTuteur == storeCatalogue.SituationFamMarie
          );
        }).length;

      if (
        parentsMaries < 2 &&
        this.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale &&
        this.DonneesFormulaireEC.infosComplementaires.regimeProtectionSociale !=
          storeCatalogue.DataId.Oui
      ) {
        const texte =
          "Vous avez indiqué être à la charge de deux parents mariés, merci de corriger la situation familiale de vos parents.";
        if (show) {
          let retour = {
            model: true,
            texte: texte,
          };
          return retour;
        }

        return [texte];
      }
    }

    // Si le candidat est à la charge d'un parent veuf.
    if (
      etesVous &&
      etesVous ==
        storeCatalogue.DataId.ChargeUnParentVeuf
    ){
      // Vérifier que le candidat a bien ajouté les informations de son parent décédé
      let parentDecede = this.DonneesFormulaireEC.listeSituationsFamiliale.filter(
        (item) => {
          return (
            item.supprimer == false &&
            item.statutParentTuteur == storeCatalogue.SituationFamDecede
          );
        }
      )[0];

      if (
        !parentDecede ||
        !parentDecede.nom ||
        !parentDecede.prenom ||
        !parentDecede.civilite ||
        !parentDecede.nationalite
      ) {
        const texte =
          "Veuillez renseigner tous les champs demandés du parent décédé.";
        if (show) {
          let retour = {
            model: true,
            texte: texte,
          };
          return retour;
        }

        return [texte];
      }
    }

    let nbTuteurPere = this.NombreTuteurParente(storeCatalogue.DataId.ParentePere, storeCatalogue.DataId.Oui);
    let nbTuteurMere = this.NombreTuteurParente(storeCatalogue.DataId.ParenteMere, storeCatalogue.DataId.Oui);
    let fileDataChargeUnParent = this.DonneesFormulaireEC.infosComplementaires.chargeUnParent;

    // Si le candidat est à la charge d'un de ses 2 parents veuf ou divorcé.
    if((etesVous ===
        storeCatalogue.DataId.ChargeUnParentVeuf
      || etesVous ===
        storeCatalogue.DataId.ChargeUnParentDivorce)
    && fileDataChargeUnParent)
    {
      // Vérifier que le parent nommé comme tuteur est bien présent :
      // Dans le cas où il a indiqué être à la charge de sa mère.
      if((fileDataChargeUnParent === storeCatalogue.DataId.GardeMere
        || fileDataChargeUnParent === storeCatalogue.DataId.TutelleMere)
        && (nbTuteurMere < 1 || nbTuteurPere > 0)
      )
      {
        const texte =
          "Vous avez indiqué être à la charge de votre mère, merci de vérifier votre saisie.";
        if (show) {
          let retour = {
            model: true,
            texte: texte,
          };
          return retour;
        }

        return [texte];
      }
      // Dans le cas où il a indiqué être à la charge de son père.
      if((fileDataChargeUnParent === storeCatalogue.DataId.GardePere
        || fileDataChargeUnParent === storeCatalogue.DataId.TutellePere)
        && (nbTuteurPere < 1 || nbTuteurMere > 0)
      )
      {
        const texte =
          "Vous avez indiqué être à la charge de votre père, merci de vérifier votre saisie.";
        if (show) {
          let retour = {
            model: true,
            texte: texte,
          };
          return retour;
        }

        return [texte];
      }
    }

    return [];
  },

  NombreTuteurParente(parente, tuteur){
    return this.DonneesFormulaireEC.listeSituationsFamiliale.filter(
          (item) => {
            return (
              item.supprimer == false &&
              item.tuteur == tuteur &&
              item.parente == parente
            );
          }
        ).length;
  },
  CreerDossier() {
    this.loader = true;
    Promise.all([
      ApiToken.post("candidatureBourseFirsi/Creer", this.DonneesFormulaireEC)
        .then((reponse) => {
          if (reponse && reponse.status === 200) {
            this.premiereEtape.creer = true;
          }
        })
        .catch((error) => {
          this.premiereEtape.creer = false;
          console.log(error);
        }),
    ])
      .then(() => {
        this.loader = false;
        this.premiereEtape.afficherMessage = true;
      })
      .catch((error) => {
        console.log(error);
        this.loader = false;
      });

    return true;
  },
  ValiderForm(ref, clesExclues) {
    ref.validate();
    let listeErreur = [];
    ref.inputs.forEach((input) => {
      if (clesExclues.length === 0 || !clesExclues.includes(input.label)) {
        if (
          (input && !input.valid && input.valid != undefined) ||
          (input.valid == undefined &&
            input.$children != undefined &&
            input.$children[0] != undefined &&
            !input.$children[0].valid)
        ) {
          let label = input.label;
          if (!label) {
            let inp = input;
            if (!inp.$attrs) {
              inp = inp[0];
            }
            label = inp.$attrs["itemprop"];
          }
          listeErreur.push(label);
        }
      }
    });

    return listeErreur;
  },
  CheckCni(cni) {
    this.loader = true;
    Promise.all([
      ApiToken.get("candidatureBourseFirsi/CheckCni/" + cni)
        .then((reponse) => {
          if (reponse.data && reponse.status === 200) {
            this.verificationCni.cniVerifie = reponse.data.fileId;
            this.verificationCni.candidatureExistante = reponse.data.candidatureExistante;
          }
        })
        .catch((error) => {
          console.log(error);
        }),
    ])
      .then(() => {
        this.loader = false;
        this.verificationCni.afficherMessage = true;
      })
      .catch((error) => {
        console.log(error);
        this.loader = false;
      });
  },
  GetCni(fileid) {
    this.loader = true;
    Promise.all([
      ApiToken.get("candidatureBourseFirsi/GetCni/" + fileid)
        .then((reponse) => {
          if (reponse.data && reponse.status === 200) {
            this.DonneesFormulaireEC.cni = reponse.data.cni;
            this.premiereEtape.cniValide = true;
            this.premiereEtape.peutCreer = reponse.data.creation;
            this.premiereEtape.creer = false;
          }
        })
        .catch((error) => {
          console.log(error);
        }),
    ])
      .then(() => {
        this.loader = false;
      })
      .catch((error) => {
        this.loader = false;
        console.log(error);
      });
  },
  async EnregistrerEtape(etape, token) {
    this.loader = true;
    // Sauvegarder conditionsGenerales (non mappé côté backend)
    const conditionsGeneralesBackup = this.DonneesFormulaireEC.conditionsGenerales;
    
    try {
      const response = await axios
        .create({
          baseURL: process.env.VUE_APP_BASE_API_URL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
            token: token, 
          },
        })
        .post(
          "candidatureBourseFirsi/SaveEtape/" + etape,
          this.DonneesFormulaireEC
        );

      // Affectation des données avec vérification
      if (response.data && response.status === 200) {
        this.DonneesFormulaireEC = JSON.parse(JSON.stringify(response.data.formulaire)); // Conversion pour retirer les observables
        // Restaurer conditionsGenerales après le rechargement
        this.DonneesFormulaireEC.conditionsGenerales = conditionsGeneralesBackup;
      } else {
        throw new Error("Réponse API invalide");
      }
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      this.loader = false;
    }
  },
  async Publiposter(token) {
    this.loader = true;
    try {
      const reponse = await axios
        .create({
          baseURL: process.env.VUE_APP_BASE_API_URL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
            token: token, 
          },
        })
        .get(
          "candidatureBourseFirsi/Publiposter/" + this.DonneesFormulaireEC.id
        );

      // Affectation des données avec vérification
      if (reponse.data && reponse.status === 200) {
        return reponse.data;
      }
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      this.loader = false;
    }
  },
  AfficherListeErreurs(listeErreurs) {
    if (listeErreurs && listeErreurs.length > 0) {
      this.dialog.informations.texte =
        "Veuillez renseigner les informations suivantes : <br>";
      listeErreurs.forEach((item) => {
        this.dialog.informations.texte += item + "<br>";
      });
      this.dialog.informations.model = true;
      return;
    }
  },
  async Signer(dataidCandidatureSoumis, token) {
    this.loader = true;
    try {
      const reponse = await axios
        .create({
          baseURL: process.env.VUE_APP_BASE_API_URL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            token: token, 
          },
        })
        .post("candidatureBourseFirsi/Signer", this.DonneesFormulaireEC);

      // Affectation des données avec vérification
      if (
        reponse.data &&
        reponse.status === 200 &&
        reponse.data.etatDuDossier.id == dataidCandidatureSoumis
      ) {
        this.dialog.informations.model = true;
        this.dialog.informations.texte = "Votre demande a bien été enregistrée";
        this.DonneesFormulaireEC = reponse.data;
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      this.loader = false;
    }
  },
};
